
import React, { useState, useEffect } from 'react';
import axios, { isCancel } from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const LoanApproveForm = ({ onClose, loanId, tableType }) => {
  const [currency, setCurrency] = useState('USD($)');
  const [rate, setRate] = useState('');
  const [loanAmount, setLoanAmount] = useState('');
  const [sourceCountry, setSourceCountry] = useState('');
  const [bankName, setBankName] = useState('');
  const [requiredTime, setRequiredTime] = useState('');
  const [dueDiligence, setDueDiligence] = useState('no');
  const [bankList, setBankList] = useState([]);
  const [countryList, setcountryList] = useState([]);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const navigate = useNavigate();

  const handleShowDecline = () => {
    setShowDeclineModal(true);
  };
  const cancelDecline = () => {
    setShowDeclineModal(false);
  };

  const handleCurrencyChange = currency => {
    setCurrency(currency);
  };

  console.log(loanId);
  console.log(tableType);
  // Fetch the list of Countries from the API
  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/countries/`,
          // 'https://finwise-backend.vercel.app/account/countries/',
          // 'https://finwiseback.finwise.com.bd/account/countries/',
          // 'http://127.0.0.1:8000/account/countries/',
          {
            headers: {
              Cookie:
                'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
            },
            withCredentials: true,
          }
        );

        // Assuming response.data contains the list of banks
        setcountryList(response.data);
        // console.log(response);
      } catch (error) {
        console.error('Error fetching the bank list:', error);
      }
    };

    fetchBankList();
  }, []);

  // Fetch the list of banks from the API
  useEffect(() => {
    const fetchBankList = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/account/bank-list/`,
          // 'https://finwise-backend.vercel.app/account/bank-list/',
          // 'https://finwiseback.finwise.com.bd/account/bank-list/',
          // 'http://127.0.0.1:8000/account/bank-list/',
          {
            headers: {
              Cookie:
                'csrftoken=YmXTCIwY0VzFyPEcOP15TL1stJiuNrZF; sessionid=l2509fh2uv9ulyzd6412afq0ufd2elpr',
            },
            withCredentials: true,
          }
        );

        setBankList(response.data);
      } catch (error) {
        console.error('Error fetching the bank list:', error);
      }
    };

    fetchBankList();
  }, []);
  // handle submit for approve loan
  const handleSubmit = async e => {
    e.preventDefault();

    const formData = {
      rate: rate,
      currency: loanAmount,
      currency_type: currency,
      name_of_the_bank: bankName,
      source_country: sourceCountry,
      due_diligence: dueDiligence,
      required_time: requiredTime,
    };

    console.log('FormData before submit:', formData);

    // Assuming `tableType` is a state or prop that determines the current table
    let url = '';
    switch (tableType) {
      case 'UPAS':
        // url = `http://127.0.0.1:8000/account/approve-loan/${loanId}/`;
        url = `${API_BASE_URL}/account/approve-loan/${loanId}/`;
        break;
      case 'FirstRefinance':
        url = `${API_BASE_URL}/account/approve-first-refinance-loan/${loanId}/`;
        break;
      case 'SecondRefinance':
        url = `${API_BASE_URL}/account/approve-second-refinance-loan/${loanId}/`;
        break;
      default:
        console.error('Invalid table type');
        return;
    }

    try {
      const response = await axios.post(url, formData, {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
        },
        withCredentials: true,
      });

      console.log('Response:', response.data);

      Swal.fire({
        title: 'Success!',
        text: 'Your request has been accepted.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });

      handleClose();
    } catch (error) {
      console.error('Error:', error);

      Swal.fire({
        title: 'Error!',
        text: 'Your request has been failed.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
  };

  // const handleSubmit = async e => {
  //   e.preventDefault();

  //   const formData = {
  //     rate: rate,
  //     currency: loanAmount,
  //     // currency_type: 'bdt',
  //     currency_type: currency,
  //     name_of_the_bank: bankName,
  //     source_country: sourceCountry,
  //     due_diligence: dueDiligence,
  //     required_time: requiredTime,
  //   };
  //   console.log(loanId);
  //   console.log('FormData before submit:', formData);
  //   try {
  //     const response = await axios.post(
  //       // `https://finwise-backend.vercel.app/account/approve-loan/${loanId}/`,
  //       // `https://finwiseback.finwise.com.bd/account/approve-loan/${loanId}/`,
  //       `http://127.0.0.1:8000/account/approve-loan/${loanId}/`,
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
  //         },
  //         withCredentials: true,
  //       }
  //     );
  //     console.log('Response:', response.data);
  //     // navigate('/dashboard');
  //        Swal.fire({
  //          title: 'Success!',
  //          text: 'Your request has been accepted.',
  //          customClass: {
  //            popup: 'w-72 h-auto p-3',
  //            title: 'text-lg',
  //            content: 'text-xs',
  //            confirmButton:
  //              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
  //          },
  //        });
  //         handleClose();
  //   } catch (error) {
  //     console.error('Error:', error);
  //        Swal.fire({
  //          title: 'Error!',
  //          text: 'Your request has been Faild.',
  //          customClass: {
  //            popup: 'w-72 h-auto p-3',
  //            title: 'text-lg',
  //            content: 'text-xs',
  //            confirmButton:
  //              'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
  //          },
  //        });
  //   }
  // };

  const handleClose = () => {
    onClose();
    // navigate('/dashboard');
  };

  const cancelLoan = async () => {
    // Assuming `tableType` is a state or prop that determines the current table
    let LoanDeclineURL = '';
    switch (tableType) {
      case 'UPAS':
        LoanDeclineURL = `${API_BASE_URL}/account/cancel-loan/${loanId}/`;
        break;
      case 'FirstRefinance':
        LoanDeclineURL = `${API_BASE_URL}/account/decline-first-refinance-loan/${loanId}/`;
        break;
      case 'SecondRefinance':
        LoanDeclineURL = `${API_BASE_URL}/account/cancel-second-refinance-loan/${loanId}/`;
        break;
      default:
        console.error('Invalid table type');
        return;
    }

    try {
      const response = await axios.post(
        LoanDeclineURL,
        { is_cancelled: true },
        // {},
        {
          headers: {
            Cookie:
              'sessionid=tzgc4a786dkl5nncrl1dkz8n1wyfn9oe; csrftoken=YrApogrEHZhFDwkZOGrbdMTk9j568kvu',
            'Content-Type': 'application/json',
            'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
          },
          withCredentials: true, // Ensure cookies are sent with the request
        }
      );

      // Log the result
      console.log('Response:', response);
      handleClose();
      // navigate('/dashboard');
    } catch (error) {
      // Handle error
      console.error('Error:', error);
    }
  };

  // Example usage:
  // cancelLoan();

  return (
    <div className="bg-AboutUsBg rounded-t-lg shadow-2xl md:p-0">
      <div>
        {/* Title Header */}
        {showDeclineModal && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 md:px-0 px-10">
            <div className="bg-AboutUsBg md:p-6 p-4 rounded-lg shadow-lg">
              <h2 className="md:text-lg text-sm font-bold md:mb-4 mb-2">
                Are you sure you want to Decline?
              </h2>
              <div className="flex justify-center space-x-4">
                <button
                  onClick={cancelLoan}
                  className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
                >
                  Yes
                </button>
                <button
                  onClick={cancelDecline}
                  className="bg-headerBtn text-white py-2 px-6 rounded-lg hover:bg-gray-600"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="bg-headerBtn p-2 md:w-full md:pl-8 pl-4 rounded-t-lg">
          <div className="flex justify-between">
            <div>
              <h2 className="text-lg md:text-2xl text-white font-bold md:mb-2">
                Approve Loans with Confidence
              </h2>
              <p className="text-xs md:text-sm text-white md:mb-2">
                Streamlined Processes for Fast and Reliable Loan Approval
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-2xl font-bold text-white hover:text-btnHover md:mr-4 mr-3 -mt-6"
            >
              &times;
            </button>
          </div>
        </div>

        {/* Form Fields */}
        <div className="bg-AboutUsBg flex flex-col items-center py-4 px-4 md:py-10 md:px-20 md:text-sm text-xs">
          <form onSubmit={handleSubmit} className="w-full max-w-5xl">
            {/* All form fields start here */}
            <div className="space-y-2 md:space-y-2">
              {/* Rate */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-44 gap-1">
                <label
                  htmlFor="rate"
                  className="block font-medium text-gray-700"
                >
                  Rate<span className="text-red-600">*</span>
                </label>
                <div className="flex md:gap-2">
                  <span className="text-3xl hidden md:block ml-3 -mt-1">:</span>
                  <div className="flex gap-3">
                    <input
                      type="text"
                      id="rate"
                      placeholder="Rate"
                      value={rate}
                      onChange={e => setRate(e.target.value)}
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                      required
                      onInput={e => {
                        e.target.value = e.target.value
                          .replace(/[^0-9.]/g, '') // Allows only numbers, comma, and decimal point
                          .replace(/(\..*?)\./g, '$1') // Ensures only one decimal point
                          .replace(/(\.\d{2})\d+/g, '$1'); // Limits to two digits after the decimal point
                      }}
                    />
                    <p className="text-gray-600 mt-2 font-semibold">
                      /per year(%)
                    </p>
                  </div>
                </div>
              </div>

              {/* Currency Tabs */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-24 gap-1">
                <label
                  htmlFor="currency"
                  className="block font-medium text-gray-700"
                >
                  Amount <span className="text-red-600">*</span>
                </label>
                <div className="flex md:gap-2">
                  <span className="text-3xl hidden md:block ml-16 -mt-1">
                    :
                  </span>
                  <div className="flex  lg:gap-3 gap-1">
                    <input
                      type="text"
                      id="currency"
                      placeholder="Amount"
                      value={loanAmount}
                      onChange={e => setLoanAmount(e.target.value)}
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                      required
                      onInput={e => {
                        // Remove non-numeric characters and format with commas every three digits
                        let value = e.target.value
                          .replace(/[^0-9]/g, '') // Allows only numbers
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Adds a comma every three digits from the right

                        e.target.value = value;
                      }}
                      onBlur={e => {
                        // Append .00 on blur if not already present
                        if (!e.target.value.includes('.')) {
                          e.target.value += '.00';
                        }
                      }}
                    />
                    {/* currency tab */}
                    <div className="flex space-x-0 rounded-sm border border-black ">
                      {['USD($)', 'EURO(€)'].map(curr => (
                        <button
                          key={curr}
                          type="button"
                          onClick={() => handleCurrencyChange(curr)}
                          className={`lg:py-1 py-0 lg:px-2 px-1.5 border border-black lg:text-sm text-[8px] lg:font-normal font-bold ${
                            currency === curr
                              ? 'bg-black text-white'
                              : 'bg-AboutBG'
                          }`}
                        >
                          {curr}
                        </button>
                      ))}
                    </div>
                    {/* <div className="flex mt-2 md:mt-0 space-x-0 rounded-sm border border-black">
                      {['BDT(৳)', 'USD($)', 'GBP(£)'].map(curr => (
                        <button
                          key={curr}
                          type="button"
                          onClick={() => handleCurrencyChange(curr)}
                          className={`md:py-0 py-1 md:px-2 px-1 border-r border-black ${
                            currency === curr
                              ? 'bg-black text-white'
                              : 'bg-AboutBG'
                          }`}
                        >
                          {curr}
                        </button>
                      ))}
                    </div> */}
                  </div>
                </div>
              </div>

              {/* Source Country */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-24 gap-1">
                <label
                  htmlFor="sourceCountry"
                  className="block font-medium text-gray-700"
                >
                  Source Country<span className="text-red-600">*</span>
                </label>
                <div className="flex md:gap-2">
                  <span className="text-3xl hidden md:block ml-4 -mt-1">:</span>

                  <div className="">
                    <select
                      id="bankName"
                      value={sourceCountry}
                      onChange={e => setSourceCountry(e.target.value)}
                      required
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                    >
                      <option value="">Select Country</option>
                      {countryList.map((bank, index) => (
                        <option key={index} value={bank[0.0]}>
                          {bank[0.0]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Name of the Bank */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-20 gap-1">
                <label
                  htmlFor="bankName"
                  className="block font-medium text-gray-700"
                >
                  Name of the Bank<span className="text-red-600">*</span>
                </label>
                <div className="flex md:gap-2">
                  <span className="text-3xl hidden md:block ml-4 -mt-1">:</span>
                  <div className="">
                    <select
                      id="bankName"
                      value={bankName}
                      onChange={e => setBankName(e.target.value)}
                      required
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                    >
                      <option value="">Select Bank</option>
                      {bankList.map((bank, index) => (
                        <option key={index} value={bank[0.0]}>
                          {bank[0.0]}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Required Time to Arrange */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-10 gap-1">
                <label
                  htmlFor="requiredTime"
                  className="block font-medium text-gray-700"
                >
                  Required Time to Arrange
                  <span className="text-red-600">*</span>
                </label>
                <div className="flex md:gap-2">
                  <span className="text-3xl hidden md:block ml-0.5 -mt-1">
                    :
                  </span>
                  <div className="flex gap-3">
                    <input
                      type="text"
                      id="requiredTime"
                      placeholder="e.g., 1 Month"
                      value={requiredTime}
                      onChange={e => setRequiredTime(e.target.value)}
                      className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                      required
                      onInput={
                        e =>
                          (e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )) // allows letters and numbers only
                      }
                    />
                    <p className="text-gray-600 mt-2 font-semibold ">
                      (Months)
                    </p>
                  </div>
                </div>
              </div>

              {/* Due Diligence Required */}
              <div className="flex flex-col md:flex-row md:items-center md:gap-20 gap-1">
                <label
                  htmlFor="dueDiligence"
                  className="block font-medium text-gray-700"
                >
                  Due Diligence Required<span className="text-red-600">*</span>
                </label>
                <div className="flex gap-2">
                  <span className="hidden md:block text-3xl -ml-5 -mt-2">
                    :
                  </span>
                  <div className="flex md:gap-3 gap-2 -mt-1">
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="dueDiligenceYes"
                        value="yes"
                        checked={dueDiligence === 'yes'}
                        onChange={e => setDueDiligence(e.target.value)}
                        className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      />
                      <label
                        htmlFor="dueDiligenceYes"
                        className="text-gray-700"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="dueDiligenceNo"
                        value="no"
                        checked={dueDiligence === 'no'}
                        onChange={e => setDueDiligence(e.target.value)}
                        className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                        required
                      />
                      <label htmlFor="dueDiligenceNo" className="text-gray-700">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button
            <div className="flex justify-center mt-4">
              <button
                type="submit"
                className="bg-btnHover text-white px-4 py-2 rounded-md shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
              >
                Approve Loan
              </button>
            </div> */}
            {/* Apply and cancel Buttons  */}
            <div className="flex md:w-full w-2/3 justify-center space-x-4 mt-6 ">
              <button
                type="submit"
                className="bg-headerBtn text-white md:py-2 py-1 md:px-6 px-2 text-xs md:text-sm rounded-xl hover:bg-btnHover"
              >
                Approve Now
              </button>
              <button
                // onClick={onCancelNewApplication}
                // onClick={cancelLoan}
                onClick={handleShowDecline}
                type="button"
                className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-2 rounded-xl hover:bg-btnHover hover:text-white"
              >
                Decline Now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoanApproveForm;


           




// extra if needed
// import React, { useState } from 'react';
// import axios from 'axios';

// const LoanApproveForm = ({ onCancelNewApplication, loanId }) => {
//   const [showNextMaturity, setShowNextMaturity] = useState(false);
//   const [currency, setCurrency] = useState('BDT');
//   const [rate, setRate] = useState('');
//   const [loanAmount, setLoanAmount] = useState('');
//   const [sourceCountry, setSourceCountry] = useState('');
//   const [bankName, setBankName] = useState('');
//   const [requiredTime, setRequiredTime] = useState('');
//   const [dueDiligence, setDueDiligence] = useState('no');

//   const handleCurrencyChange = currency => {
//     setCurrency(currency);
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();

//     const data = {
//       rate: `${rate}%`,
//       currency: loanAmount,
//       currency_type: currency.toLowerCase(),
//       name_of_the_bank: bankName,
//       source_country: sourceCountry,
//       due_diligence: dueDiligence,
//       required_time: requiredTime,
//     };
//     // const data = {
//     //   rate: '25%',
//     //   currency: '12000',
//     //   currency_type: 'bdt',
//     //   name_of_the_bank: 'BRAC Bank Ltd.',
//     //   source_country: 'Bangladesh',
//     //   due_diligence: 'no',
//     //   required_time: '20',
//     // };

//     console.log(loanId);
//     try {
//       const response = await axios.post(
//         `https://finwise-b.vercel.app/account/approve-loan/${loanId}/`, // Use dynamic loanId here

//         data,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'X-CSRFToken': 'z91BDRm6OBq66qusVK8HCtvtdW686hFC',
//           },
//           withCredentials: true,
//         }
//       );
//       console.log('Response:', response.data);
//       // Handle success (e.g., show a success message, clear form, etc.)
//     } catch (error) {
//       console.error('Error:', error);
//       // Handle error (e.g., show an error message)
//     }
//   };

//   return (
//     <div className="md:p-0 bg-AboutUsBg rounded-t-lg shadow-2xl">
//       <div>
//         {/* title header */}
//         <div className="bg-headerBtn md:w-full p-2 md:pl-8 pl-4 text-left rounded-t-lg">
//           <div className="flex justify-between">
//             <div>
//               <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
//                 Approve Loans with Confidence
//               </h2>
//               <p className="md:mb-2 text-xs md:text-sm text-white">
//                 Streamlined Processes for Fast and Reliable Loan Approval
//               </p>
//             </div>
//             <button
//               onClick={onCancelNewApplication}
//               className="md:mr-4 mr-3 -mt-6 text-white text-2xl font-bold hover:text-btnHover"
//             >
//               &times;
//             </button>
//           </div>
//         </div>

//         {/* form fields */}
//         <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-20">
//           <form onSubmit={handleSubmit} className="w-full max-w-3xl">
//             <div className="md:space-y-2 space-y-2">
//               {/* Rate */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-44 gap-1">
//                 <div>
//                   <label
//                     htmlFor="rate"
//                     className="block font-medium text-gray-700"
//                   >
//                     <div className="flex md:flex-col gap-1">
//                       <span>
//                         Rate<span className="text-red-600">*</span>
//                       </span>
//                     </div>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-1 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div className="flex gap-3">
//                     <input
//                       type="text"
//                       id="rate"
//                       placeholder="Rate"
//                       value={rate}
//                       onChange={e => setRate(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     />
//                     <p className="text-gray-600 mt-2 font-semibold">
//                       /per year(%)
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Currency Tabs */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1">
//                 <div>
//                   <label
//                     htmlFor="currency"
//                     className="block font-medium text-gray-700"
//                   >
//                     Currency<span className="text-red-600">*</span>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-14 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div className="flex gap-3">
//                     <input
//                       type="text"
//                       id="currency"
//                       placeholder="$3000"
//                       value={loanAmount}
//                       onChange={e => setLoanAmount(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     />
//                     <div className="flex mt-2 md:mt-0 space-x-0 rounded-sm border border-black">
//                       {['BDT(৳)', 'USD($)', 'GBP(£) '].map(curr => (
//                         <button
//                           key={curr}
//                           type="button"
//                           onClick={() => handleCurrencyChange(curr)}
//                           className={`md:py-0 py-1 md:px-2 px-1 border-r border-black ${
//                             currency === curr
//                               ? 'bg-black text-white'
//                               : 'bg-AboutBG'
//                           }`}
//                         >
//                           {curr}
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Source country */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//                 <div>
//                   <label
//                     htmlFor="sourceCountry"
//                     className="block font-medium text-gray-700"
//                   >
//                     Source country<span className="text-red-600">*</span>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-4 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div>
//                     <select
//                       id="sourceCountry"
//                       value={sourceCountry}
//                       onChange={e => setSourceCountry(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     >
//                       <option value="">Select Country</option>
//                       <option value="Bangladesh">Bangladesh</option>
//                       <option value="India">India</option>
//                       {/* Add more options as needed */}
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* Name of the bank */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-20 gap-1 ">
//                 <div>
//                   <label
//                     htmlFor="bankName"
//                     className="block font-medium text-gray-700"
//                   >
//                     Name of the bank<span className="text-red-600">*</span>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-4 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div>
//                     <select
//                       id="bankName"
//                       value={bankName}
//                       onChange={e => setBankName(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     >
//                       <option value="">Select Bank</option>
//                       <option value="AB Bank PLC">AB Bank Ltd.</option>
//                       <option value="Agrani Bank PLC">Agrani Bank PLC</option>
//                       <option value="BRAC Bank PLC">BRAC Bank PLC</option>
//                       {/* Add more options as needed */}
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* Required time to arrange */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-10 gap-1 ">
//                 <div>
//                   <label
//                     htmlFor="requiredTime"
//                     className="block font-medium text-gray-700"
//                   >
//                     Required time to arrange
//                     <span className="text-red-600">*</span>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-5 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div>
//                     <input
//                       type="text"
//                       id="requiredTime"
//                       placeholder="e.g., 1 Month"
//                       value={requiredTime}
//                       onChange={e => setRequiredTime(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Due diligence */}
//               <div className="flex flex-col md:flex-row md:items-center md:space-x-0 md:gap-24 gap-1 ">
//                 <div>
//                   <label
//                     htmlFor="dueDiligence"
//                     className="block font-medium text-gray-700"
//                   >
//                     Due diligence<span className="text-red-600">*</span>
//                   </label>
//                 </div>
//                 <div className="flex md:gap-2">
//                   <div>
//                     <span className="text-3xl hidden md:block ml-6 -mt-1">
//                       :
//                     </span>
//                   </div>
//                   <div>
//                     <select
//                       id="dueDiligence"
//                       value={dueDiligence}
//                       onChange={e => setDueDiligence(e.target.value)}
//                       className="md:w-96 w-48 p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//                       required
//                     >
//                       <option value="no">No</option>
//                       <option value="yes">Yes</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Buttons */}
//             <div className="mt-4 flex justify-between">
//               <button
//                 type="submit"
//                 className="bg-blue-500 text-white py-2 px-4 rounded-md"
//               >
//                 Approve
//               </button>
//               <button
//                 type="button"
//                 onClick={onCancelNewApplication}
//                 className="bg-red-500 text-white py-2 px-4 rounded-md"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoanApproveForm;
